<template>
  <div class="originInfo">
    <QS-h4-title title="来源信息"/>
    <form-text-box
      ref="FormTextBox"
      :dataList="dataList"
      :column="3"
      :model="carLease_obj"
      :rules="carLease_obj_rules"
    />
  </div>
</template>
<script>
import { getCarProvider } from '@/api/carManage'

export default {
  name: 'OriginInfo',
  data() {
    return {
      dataList: [
        {
          el: 'select',
          itemConfig: {
            label: '车源方',
            prop: 'providerId',
          },
          elConfig: {
            events: {
              change: this.changeCustmerMes,
            },
            options: { // 下拉数据
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '采购方式',
            prop: 'purchaseMode',
            value: 2,
          },
          elConfig: {
            events: {
              change: this.changePurchaseMode,
            },
            options: { // 下拉数据
              label: 'label',
              value: 'value',
              list: [
                {
                  value: 1,
                  label: '购买',
                },
                {
                  value: 2,
                  label: '租用',
                },
              ],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '支付形式',
            prop: 'payForm',
          },
          elConfig: {
            events: {
              change: this.changePayType,
            },
            options: { // 下拉数据
              label: 'label',
              value: 'value',
              list: [
                {
                  value: 1,
                  label: '一次性支付',
                },
                {
                  value: 2,
                  label: '分期付款',
                },
              ],
            },
          },
        },
        {
          el: 'DeptSelect',
          itemConfig: {
            label: '所属部门',
            prop: 'deptId',
          },
          elConfig: {
            multiple: false,
            isAll: false,
          },
        },
      ],
      // 车源方枚举
      carProviderList: [],
      // 来源信息表单
      carLease_obj: {
        providerId: '', // 车源方ID
        customerName: '', // 车源方中文
        purchaseMode: 2, // 购买方式
        purchaseModeName: '租用', // 购买方式中文
        payForm: '', // 支付形式
        payName: '', // 支付形式中文
      },
      // 来源信息表单校验
      carLease_obj_rules: {
        providerId: [
          {
            required: true,
            message: '车源方不能为空',
            trigger: 'change',
          },
        ],
        purchaseMode: [
          {
            required: true,
            message: '采购方式不能为空',
            trigger: 'change',
          },
        ],
        payForm: [
          {
            required: true,
            message: '支付形式不能为空',
            trigger: 'change',
          },
        ],
        deptId: [
          {
            required: true,
            message: '所属部门不能为空',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getCarProviderFun()
  },
  methods: {
    // 获取车源方枚举
    async getCarProviderFun() {
      const { code, data } = await getCarProvider({ state: 1, serviceType: 0 })
      if (code === 1) {
        this.carProviderList = data.items
        this.$refs.FormTextBox?.setItemData({ elConfigKey: 'list', key: 'providerId', data: data.items })
      }
    },
    // 选择车源方
    changeCustmerMes(id) {
      this.carProviderList.forEach((item) => {
        if (item.id === id) {
          this.carLease_obj.customerName = item.name
        }
      })
    },
    // 选择采购方式
    changePurchaseMode(type) {
      if (Number(type) === 1) {
        this.carLease_obj.purchaseModeName = '购买'
      } else if (Number(type) === 2) {
        this.carLease_obj.purchaseModeName = '租用'
      }
    },
    // 选择支付方式
    changePayType(type) {
      if (type === 1) {
        this.carLease_obj.payName = '分期付款'
      } else if (type === 2) {
        this.carLease_obj.payName = '一次性支付'
      }
    },
  },
}
</script>
<style lang='scss' scoped>

</style>

